import { default as brandManagementFr } from '@centric-os/brand-management/src/locale/fr';
import { navigationFr } from './navigation-fr';

export default {
  buttons: {
    change: 'Changer',
    discard: 'Annuler',
    save: 'Enregistrer',
    select: 'Sélectionner',
  },
  inputSwitch: {
    active: 'Actif',
    inactive: 'Inactif',
  },
  documentTitleWrapper: '{title} - CentricOS',
  errorMessages: {
    400: 'Introuvable',
    404: 'Introuvable',
    500: 'Mauvaise demande',
    503: 'Erreur serveur',
    genericRequired: 'Obligatoire',
    genericApiError: "Une erreur s'est produite de notre côté, veuillez réessayer plus tard.",
    apiError: 'Une erreur est survenue sur le serveur : {error}',
    unauthorized: "L'utilisateur n'est pas autorisé.",
    checkInformation: 'Quelque chose doit être mis à jour',
    checkInformationBody:
      'Complétez les champs obligatoires, puis enregistrez lorsque vous êtes prêt',
    email: 'Entrez une adresse email valide',
    fileLimit: 'Un seul fichier peut être sélectionné',
    fileSize: 'Le fichier ne peut pas dépasser {maxFileSize}',
    fileType: 'Format de fichier non supporté',
    imageFileType: "Format d'image non supporté",
    max: 'Nombre maximal de caractères atteint : {count}',
    maxValue: 'Valeur maximale atteinte de {maxValue} {record}',
    minValue: 'Nécessite un minimum de {minValue} {record}',
    greaterThan: 'Doit être supérieur à {greaterThan}',
    lessThan: 'Doit être inférieur à {lessThan}',
    required: 'Ce champ est obligatoire',
    startSpace: 'La valeur ne peut pas commencer par un espace vide',
    endSpace: 'La valeur ne peut pas se terminer par un espace vide',
    invalidIP: 'Adresse IP invalide',
    invalidURL: 'URL invalide',
    invalidType: 'Doit être uniquement {type}',
    invalidDomain: 'Domaine invalide',
    calendar: {
      endDateBeforeStartDate:
        "La date et l'heure de fin doivent être après la date et l'heure de début",
      pickupOrDropoff: 'La prise en charge ou la dépose est requise',
      repeat: 'La répétition est requise',
    },
    invalidNumber: 'Doit être un nombre valide',
    form: {
      invalidFormSubmit: 'Veuillez corriger les erreurs dans le formulaire !',
      fields: {
        error: '{field}: {error}',
        formatedError: '{0}',
      },
    },
    menu: {
      uniqueLanguageKey: 'Choisissez une nouvelle langue—celle-ci est déjà sélectionnée',
    },
  },
  multiElementSelect: {
    tooltip: `Sélectionnez plusieurs éléments rapidement ! Cliquez sur le premier élément, maintenez Shift, \n puis cliquez sur un deuxième. Tous les éléments entre les deux seront sélectionnés.`,
  },
  calendar: {
    todayLabel: "Aujourd'hui",
    yesterdayLabel: 'Hier',
    currentWeekLabel: 'Semaine en cours',
    lastWeekLabel: 'Semaine dernière',
    currentMonthLabel: 'Mois en cours',
    lastMonthLabel: 'Mois dernier',
    clear: 'Effacer',
    today: "Aujourd'hui",
  },
  imageSelect: {
    dragMessage: 'Faites glisser et déposez .jpg, .jpeg ou .png',
    emptyMessage: 'Téléchargez une image',
    removeImage: "Supprimer l'image",
    remove: "Supprimer l'image",
    infoMessage: 'Vous pouvez télécharger des fichiers .jpg, .jpeg ou .png',
    download: 'Télécharger',
    uploadNew: 'Télécharger nouveau',
    changeImage: "Changer l'image",
    selectImage: "Sélectionner l'image",
    downloadFilenameFormat: 'Image {date} à {time}{extension}',
    downloadError: "Échec du téléchargement de l'image",
    downloadErrorDetail:
      "Une erreur s'est produite lors du téléchargement de l'image. Veuillez réessayer.",
    fetchError: 'Échec de la récupération du fichier : {status}',
  },
  fileSelect: {
    filesOnly: '({fileType} fichiers uniquement)',
    uploadFile: 'Télécharger un fichier',
    remove: 'Supprimer',
  },
  tableFilter: {
    search: 'Recherche',
    selectedItemsLabel: '{total} {value} sélectionné(s)',
  },
  dropdown: {
    search: 'Recherche',
  },
  na: 'N/D',
  pendingUserName: 'Utilisateur en attente',
  statusCard: {
    header: 'Statut',
    active: 'Actif',
    inactive: 'Inactif',
  },
  tags: {
    active: 'Actif',
    inactive: 'Inactif',
  },
  refundStatus: {
    full: 'Remboursé intégralement',
    partial: 'Remboursé partiellement',
  },
  user: {
    fullName: '{firstName} {lastName}',
    pending: 'Utilisateur en attente',
  },
  deleteFooter: {
    label: 'Zone dangereuse',
    action: 'Supprimer',
  },
  deleteDialog: {
    header: "Supprimer l'enregistrement",
    messageAlert: 'Êtes-vous sûr de vouloir supprimer ?',
    acceptLabel: 'Supprimer',
    rejectLabel: 'Annuler',
  },
  confirmDeleteDialog: {
    header: `Confirmez que vous voulez supprimer "{recordName}"`,
    body: `Ceci est une action permanente. Toutes les données liées à ce {type} seront effacées. Pour confirmer, tapez le nom du {type} et sélectionnez Supprimer.`,
    placeholder: 'Entrez le nom du {type}',
    deleteLabel: 'Supprimer',
    cancelLabel: 'Annuler',
  },
  discardDialog: {
    header: 'Annuler les modifications',
    createMessageAlert: 'Toutes les modifications que vous avez apportées seront perdues.',
    editMessageAlert: 'Toutes les modifications que vous avez apportées seront annulées.',
    acceptLabel: 'Annuler',
    rejectLabel: 'Annuler',
  },
  leaveDialog: {
    header: 'Vous avez des modifications non enregistrées',
    message: 'Toutes les modifications seront perdues. Êtes-vous sûr de vouloir quitter ?',
    acceptLabel: 'Quitter',
    rejectLabel: 'Rester',
  },
  errorDialog: {
    header: "Corrigez l'(es) erreur(s) et enregistrez à nouveau",
    message: "Vous avez des erreurs dans l'onglet {tab}.",
    acceptLabel: 'Corriger les erreurs',
    rejectLabel: '',
  },
  cancelForm: {
    header: 'Vous avez des modifications non enregistrées',
    message: 'Si vous annulez, toutes les modifications seront perdues.',
    acceptLabel: 'Quitter',
    rejectLabel: 'Rester',
  },
  form: {
    actions: {
      save: 'Enregistrer',
      cancel: 'Annuler',
    },
    edit: {
      title: 'Vous avez des modifications non enregistrées',
    },
  },
  barcodeScannerSplashDialog: {
    title: 'Scannez les codes-barres en déplacement',
    content:
      'Utilisez votre téléphone pour scanner des codes-barres, mettre à jour les prix et créer des articles. Pour des tâches plus importantes, passez à votre bureau.',
    closeButtonLabel: 'Pas maintenant',
    redirectButtonLabel: 'Commencer à scanner',
  },
  ...navigationFr,
  ...brandManagementFr,
};
